export const ROLE_USER = 'ROLE_USER';
export const ROLE_EMPLOYEE = 'ROLE_EMPLOYEE';
export const ROLE_COMPANY_ADMIN = 'ROLE_COMPANY_ADMIN';
export const ROLE_BMM_ADMIN = 'ROLE_BMM_ADMIN';
export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
export const ROLE_SUPER_GROUP_ADMIN = 'ROLE_SUPER_GROUP_ADMIN';

export const ADMIN_ROLES = [ROLE_COMPANY_ADMIN, ROLE_BMM_ADMIN, ROLE_SUPER_ADMIN, ROLE_SUPER_GROUP_ADMIN];
